import { useEffect } from 'react'

export function useWebviewNativeEnhancements(isInsideWebView?: boolean) {
  useEffect(() => {
    if (!isInsideWebView || typeof window === 'undefined') {
      return
    }

    const doc = window.document
    if (!doc) return

    const viewportMeta = doc.querySelector('meta[name="viewport"]')
    if (viewportMeta) {
      viewportMeta.setAttribute(
        'content',
        'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      )
    } else {
      const meta = doc.createElement('meta')
      meta.name = 'viewport'
      meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover'
      doc.getElementsByTagName('head')[0].appendChild(meta)
    }

    let touchStartY = 0
    const preventPullToRefresh = (e: TouchEvent) => {
      if (window.scrollY === 0) {
        touchStartY = e.touches[0].clientY
      }
    }

    const preventPullToRefreshMove = (e: TouchEvent) => {
      if (window.scrollY === 0 && touchStartY > 0 && e.touches[0].clientY > touchStartY) {
        e.preventDefault()
      }
    }

    const preventZoom = (e: TouchEvent) => {
      if (e.touches.length > 1) {
        e.preventDefault()
      }
    }

    let lastTouchEnd = 0
    const preventDoubleTapZoom = (e: TouchEvent) => {
      const now = Date.now()
      const target = e.target as HTMLElement

      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable ||
        target.closest('input, textarea, [contenteditable="true"]')
      ) {
        return
      }

      if (now - lastTouchEnd <= 300) {
        e.preventDefault()
      }
      lastTouchEnd = now
    }

    doc.addEventListener('touchstart', preventPullToRefresh, { passive: true })
    doc.addEventListener('touchmove', preventPullToRefreshMove, { passive: false })
    doc.addEventListener('touchmove', preventZoom, { passive: false })
    doc.addEventListener('touchend', preventDoubleTapZoom, { passive: false })

    doc.documentElement.style.scrollBehavior = 'smooth'

    const preventSelection = (e: Event) => {
      const target = e.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable ||
        target.closest('input, textarea, [contenteditable="true"]')
      ) {
        return
      }
      if (window.getSelection) {
        const selection = window.getSelection()
        if (selection && selection.rangeCount > 0) {
          selection.removeAllRanges()
        }
      }
    }

    const preventSelectStart = (e: Event) => {
      const target = e.target as HTMLElement
      if (
        target.tagName === 'INPUT' ||
        target.tagName === 'TEXTAREA' ||
        target.isContentEditable ||
        target.closest('input, textarea, [contenteditable="true"]')
      ) {
        return
      }
      e.preventDefault()
    }

    doc.addEventListener('selectstart', preventSelectStart)
    doc.addEventListener('mousedown', preventSelection)
    doc.addEventListener('touchstart', preventSelection)

    return () => {
      doc.removeEventListener('touchstart', preventPullToRefresh)
      doc.removeEventListener('touchmove', preventPullToRefreshMove)
      doc.removeEventListener('touchmove', preventZoom)
      doc.removeEventListener('touchend', preventDoubleTapZoom)
      doc.removeEventListener('selectstart', preventSelectStart)
      doc.removeEventListener('mousedown', preventSelection)
      doc.removeEventListener('touchstart', preventSelection)
    }
  }, [isInsideWebView])

  useEffect(() => {
    if (!isInsideWebView || typeof window === 'undefined') {
      return
    }

    const doc = window.document
    if (!doc) return

    doc.body.classList.add('webview-native')
    doc.documentElement.classList.add('webview-native')

    return () => {
      doc.body.classList.remove('webview-native')
      doc.documentElement.classList.remove('webview-native')
    }
  }, [isInsideWebView])
}
